import { useTranslate } from 'react-translate';
import { Translation } from '../types';

type UseAppTranslateType = (key?: string) => Translation;
const useAppTranslate: UseAppTranslateType = (key = 'App') => useTranslate(key);

export default useAppTranslate;
